import { attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  thumbnail: attr(),
  embed: attr(),
  description: attr(),
  title: attr()
});
